export interface ErrorComponentProps<TError = Error> {
  error: TError;
  info?: {
    componentStack: string;
  };
  reset: () => void;
}

export class UnauthorizedError extends Error {
  constructor(message = "User is not authorized to access this page") {
    super(message);
    this.name = "UnauthorizedError";
  }
}

export class MarketplaceAccessDeniedError extends Error {
  constructor(message = "User does not have Basic Marketplace Access") {
    super(message);
    this.name = "MarketplaceAccessDeniedError";
  }
}
